import { $elementChild } from "@grindex-common/helpers/elements";
import { Resolution } from "@grindex-common/helpers/Resolution.class";
import { addListener } from "@grindex-common/helpers/domManipulation";
import { debounce } from "@grindex-common/helpers/debounce";

const resolution = new Resolution();
const MAX_CELLS_XS = 1;
const MAX_CELLS_LG = 4;
const MAX_CELLS_XL = 6;
const START_INDEX = 1;
const CLASS_FIRST_VISIBLE = "first-visible";

class SpecTable {
	constructor($module) {
		this.$module = $module;
		this.$scrollRight = $elementChild($module, "scroll-right");
		this.$scrollLeft = $elementChild($module, "scroll-left");
		this.$tableCells = Array.prototype.filter.call($module.querySelectorAll("[data-col]"), ($td) => {
			return $td.dataset.col !== "0";
		});

		this.firstVisibleIndex = START_INDEX;

		this.cellCount = Math.max.apply(
			Math,
			Array.prototype.map.call(this.$tableCells, ($td) => {
				return $td.cellIndex;
			}),
		);

		this.visibleCount = MAX_CELLS_XL;
		this.setVisibleCount();

		addListener(this.$scrollRight, "click", this.scrollRight.bind(this));
		addListener(this.$scrollLeft, "click", this.scrollLeft.bind(this));
		addListener(window, "resize", debounce(this.reEvaluateTable.bind(this), 200));

		this.toggleCellsVisibility(true);
	}

	setVisibleCount() {
		if (resolution.isMobile()) {
			this.visibleCount = Math.min(MAX_CELLS_XS, this.cellCount);
		} else if (resolution.isTablet() || resolution.isDesktop()) {
			this.visibleCount = Math.min(MAX_CELLS_LG, this.cellCount);
		} else {
			this.visibleCount = Math.min(MAX_CELLS_XL, this.cellCount);
		}
	}

	scrollRight() {
		if (this.$scrollRight.classList.contains("disabled")) {
			return;
		}

		if (this.visibleCount >= this.cellCount + 1) {
			return;
		}

		this.firstVisibleIndex++;

		this.toggleCellsVisibility();
	}

	scrollLeft() {
		if (this.$scrollLeft.classList.contains("disabled")) {
			return;
		}

		if (this.firstVisibleIndex === START_INDEX) {
			return;
		}

		this.firstVisibleIndex--;

		this.toggleCellsVisibility();
	}

	toggleCellsVisibility(initial) {
		this.showHideScrollLeft();
		this.showHideScrollRight();

		this.$tableCells.forEach(($cell) => {
			if ($cell.cellIndex === this.firstVisibleIndex) {
				$cell.classList.add(CLASS_FIRST_VISIBLE);
			} else {
				$cell.classList.remove(CLASS_FIRST_VISIBLE);
			}

			if ($cell.cellIndex < this.firstVisibleIndex || $cell.cellIndex >= this.firstVisibleIndex + this.visibleCount) {
				if ($cell.dataset.col !== "0") {
					$cell.classList.add("hidden");
				}
			} else if (!initial) {
				$cell.classList.remove("hidden");
			}
		});
	}

	reEvaluateTable() {
		const previousMaxValue = this.visibleCount;

		this.setVisibleCount();

		if (previousMaxValue !== this.visibleCount) {
			this.toggleCellsVisibility();
		}
	}

	showHideScrollLeft() {
		if (this.firstVisibleIndex === START_INDEX) {
			this.$scrollLeft.classList.add("disabled");
		} else {
			this.$scrollLeft.classList.remove("disabled");
		}
	}

	showHideScrollRight() {
		if (this.firstVisibleIndex + this.visibleCount > this.cellCount) {
			this.$scrollRight.classList.add("disabled");
		} else {
			this.$scrollRight.classList.remove("disabled");
		}
	}
}

export { SpecTable };
